// eslint-disable-next-line import/prefer-default-export
export const SET_SELECTED_STAFF = 'SET_SELECTED_STAFF';
